export default __webpack_public_path__ + "static/media/layers2.63909b88.png";